<script lang="ts">
    import {Card, Listgroup, ListgroupItem, Spinner} from "flowbite-svelte";
    import EmployeeAvatar from "$lib/components/EmployeeAvatar.svelte";
    import type {HrTodos} from "$lib/types/todos";

    export let hrTodos: HrTodos;
</script>


<div class="grid grid-cols-3 gap-3">
    <Card class="h-min" padding="xl" size="md">
        <h5 class="text-center text-xl text-neutral-600 dark:text-white mb-5 -mt-2">Bewerber Erinnerungen</h5>

        {#if hrTodos && hrTodos?.contractSignatures}

            {#if hrTodos.contractSignatures.waitingForEmployee?.length > 0}
                <div class="max-h-[200px] overflow-y-auto">
                    <Listgroup items={hrTodos.contractSignatures.waitingForEmployee}
                               let:item
                               class="border-0 dark:!bg-transparent">
                        <div class="flex items-center space-x-4 rtl:space-x-reverse">
                            <EmployeeAvatar employee={item.contract.employee}/>
                            <div class="flex-1 min-w-0">
                                <p class="text-sm font-medium text-gray-900 truncate dark:text-white">
                                    <a href="/employee/{item.contract.employee.uuid}">{item?.contract.employee.name}</a>
                                </p>
                                <p class="text-sm text-gray-500 truncate dark:text-gray-400">
                                    Erwarte Mitarbieterunterschrift
                                </p>
                            </div>

                        </div>
                    </Listgroup>
                </div>
            {/if}
        {:else}
            <Spinner/>
        {/if}
    </Card>
    <Card class="h-min" padding="xl" size="md">
        <h5 class="text-center text-xl text-neutral-600 dark:text-white mb-5 -mt-2">Mitarbeiter Erinnerungen</h5>
        {#if hrTodos && hrTodos.contractSignatures?.waitingForHR?.length > 0}
            <div class="max-h-[200px] overflow-y-auto">
                <Listgroup class="border-0 dark:!bg-transparent">
                    {#each hrTodos.contractSignatures.waitingForHR as item, i}
                        <ListgroupItem>
                            <div class="flex items-center space-x-4 rtl:space-x-reverse">
                                <EmployeeAvatar employee={item.contract.employee}/>
                                <div class="flex-1 min-w-0">
                                    <p class="text-sm font-medium text-gray-900 truncate dark:text-white">
                                        <a href="/employee/{item.contract.employee.uuid}">{item?.contract.employee.name}</a>
                                    </p>
                                    <p class="text-sm text-gray-500 truncate dark:text-gray-400">
                                        Erwarte HR-Unterschrift
                                    </p>
                                </div>
                            </div>
                        </ListgroupItem>
                    {/each}
                </Listgroup>
            </div>
        {/if}
    </Card>
    <Card class="h-min" padding="xl" size="md">
        <h5 class="text-center text-xl text-neutral-600 dark:text-white mb-5 -mt-2">Generelle Reminder</h5>
    </Card>
</div>
